enum ActionTypes {
  ADD_QUICKLOOK_PREVIEW = "ADD_QUICKLOOK_PREVIEW",
  UPDATE_QUICKLOOK_PREVIEWS = "UPDATE_QUICKLOOK_PREVIEWS",
  SET_GEO_MAP = "SET_GEO_MAP",
  STORE_LAST_SHAPE = "STORE_LAST_SHAPE",
  STORE_KML_SHAPE = "STORE_KML_SHAPE",
  REMOVE_LAST_SHAPE = "REMOVE_LAST_SHAPE",
  CONVERT_LAST_SHAPE_IN_POLYGON_TYPE = "CONVERT_LAST_SHAPE_IN_POLYGON_TYPE",
  REMOVE_KML_SHAPE = "REMOVE_KML_SHAPE",
  SET_SUGGESTIONS = "SET_SUGGESTIONS",
  REMOVE_SUGGESTIONS = "REMOVE_SUGGESTIONS",
  UPDATE_MAP_POSITION = "UPDATE_MAP_POSITION",
  HIDE_ALL_QUICKLOOK_PREVIEWS = "HIDE_ALL_QUICKLOOK_PREVIEWS",
  SET_SEARCH_BY_PRODUCTS = "SET_SEARCH_BY_PRODUCTS",
  ADD_SCENETOCUT = "ADD_SCENETOCUT",
  ADD_CUTSCENE = "ADD_CUTSCENE",
  ADD_LOADINGSCENE = "ADD_LOADINGSCENE",
  REMOVE_LOADINGSCENE = "REMOVE_LOADINGSCENE",
  REPLACE_SCENESTOCUT = "REPLACE_SCENESTOCUT",
  REPLACE_CUTSCENES = "REPLACE_CUTSCENES",
  REPLACE_LOADINGSCENES = "REPLACE_LOADINGSCENESS",
  SET_SEARCH_PRODUCT_IDS = "SET_SEARCH_PRODUCT_IDS",
  CHANGE_ROUTINE_STATUS= "CHANGE_ROUTINE_STATUS",
}
export default ActionTypes
